import { Box, Stack, Typography, Container, Grid } from '@mui/material';
import { ReactElement } from 'react';
import { Link } from 'react-router-dom';

import { useDeviceType } from '@app/hooks/useBrowserHooks';
import {
  PRIVACY_POLICY_LINK,
  TERMS_CUSTOMER_LINK,
} from '@app/static/constants';
import { imageAssets, theme } from '@app/theme';

interface BottomMenuProps {
  menuItems: {
    target?: React.HTMLAttributeAnchorTarget;
    text: string;
    to: string;
  }[];
  shouldShowMenuItems?: boolean;
}

export function BottomMenu(props: BottomMenuProps): ReactElement {
  const { menuItems, shouldShowMenuItems = true } = props;
  const currentYear = new Date().getFullYear();
  const { isDesktop } = useDeviceType();

  return (
    <Box
      sx={{
        bgcolor: theme.palette.primary.dark,
        color: theme.palette.neutral.white,
      }}
    >
      <Container sx={{ py: isDesktop && shouldShowMenuItems ? 8 : 4 }}>
        {isDesktop && shouldShowMenuItems && (
          <>
            <Grid container alignItems="center" spacing={4} sx={{ mb: 10 }}>
              <Grid item xs={12} md={4}>
                <img
                  src={imageAssets.logoInversion}
                  alt="Logo"
                  style={{ width: '150px' }}
                />
              </Grid>
              <Grid item xs={12} md={8}>
                <Stack direction="row" spacing={4} justifyContent="flex-end">
                  <Stack direction="column" spacing={1}>
                    {menuItems
                      .slice(0, 3)
                      .map(({ text, to, target }, index) => (
                        <Link
                          key={index}
                          to={to}
                          style={{ color: 'inherit', textDecoration: 'none' }}
                          target={target}
                        >
                          <Typography>{text}</Typography>
                        </Link>
                      ))}
                  </Stack>
                  <Stack direction="column" spacing={1}>
                    {menuItems.slice(3).map(({ text, to, target }, index) => (
                      <Link
                        key={index}
                        to={to}
                        style={{ color: 'inherit', textDecoration: 'none' }}
                        target={target}
                      >
                        <Typography>{text}</Typography>
                      </Link>
                    ))}
                  </Stack>
                </Stack>
              </Grid>
            </Grid>
          </>
        )}
        <Box
          sx={{
            alignItems: 'center',
            borderTop:
              isDesktop && shouldShowMenuItems ? '1px solid white' : 'none',
            display: 'flex',
            flexDirection: isDesktop ? 'row' : 'column-reverse',
            gap: 2,
            justifyContent: 'space-between',
            pt: isDesktop && shouldShowMenuItems ? 3 : 'none',
          }}
        >
          <Typography variant="body2">
            ©{currentYear} All Rights Reserved
          </Typography>
          <Stack direction="row" spacing={2}>
            <Link
              to={TERMS_CUSTOMER_LINK}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'inherit', textDecoration: 'none' }}
            >
              <Typography variant="body2">Term & Condition</Typography>
            </Link>
            <Link
              to={PRIVACY_POLICY_LINK}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'inherit', textDecoration: 'none' }}
            >
              <Typography variant="body2">Privacy Policy</Typography>
            </Link>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
}
